import { render, staticRenderFns } from "./RespostaRadio.vue?vue&type=template&id=45aa813f"
import script from "./RespostaRadio.vue?vue&type=script&lang=js"
export * from "./RespostaRadio.vue?vue&type=script&lang=js"
import style0 from "./RespostaRadio.vue?vue&type=style&index=0&id=45aa813f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports